import 'react-native-gesture-handler';
import { NavigationActions, CommonActions } from '@react-navigation/native';

import React, { Component } from 'react'
import { StackActions } from '@react-navigation/native';
import { Stylesheet,
         Text,
         Alert,
         View,
         ImageBackground,
         Image,
         TouchableWithoutFeedback,
         StatusBar,
         TextInput,
         SafeAreaView,
         Keyboard,
         TouchableOpacity,
         KeyboardAvoidingView } from 'react-native'
import Tabs from './Tabs';
import * as RootNavigation from './../RootNavigation';
import AppLoader, { showLoader, loaderRef, hideLoader } from './AppLoader';

         export default class Splash extends Component {
  constructor(props) {
        super(props);
        this.state = {
                id: '',
                role: '',
                location: '',                
            }
            /*
              this.handleChange = this.handleChange.bind(this);
                  this.handleSubmit = this.handleSubmit.bind(this);
            */
    };

  componentDidMount() {
    //getDBConnection();
    //console.log(this.props.navigation)
    setTimeout(() => this.props.navigation.reset({
        index: 0,
        routes: [{ name: 'Tabs' }],
        }), 2000);
/*
     getLoginState().then((id)=>{
      this.setState({id:id})
    console.log(id);

  return id ? console.log(id): this.setState({id:null});
  }).catch((error) => {
    console.error(error);
});
     getLoginRole().then((role)=>{
       this.setState({role:role})
        console.log(role)
  return role ? setTimeout(() => this.props.navigation.replace(role), 2000) : setTimeout(() => this.props.navigation.replace('LoginScreen'), 2000)

  }).catch((error) => {
    console.error(error);
});
  */
  //clearAll();  //this.setState({role:role});
  //console.log(this.state.role);
   //StoreLoginState('customerHome');
      
       
      //Alert.alert(this.state.email);
          
    }      // console.log(this.state.email);
        
       
    
    render() {
      


          return(
        <SafeAreaView>
        <View style={{flex:1,backgroundColor:'white', justifyContent:'center', alignContent:'center'}}>
        
     <Image
        style={{width:350,height:150, alignItems:'center', justifyContent:'center', left:100, marginTop:'50%'}}
        source={require('../assets/Splash.jpg')}
        resizeMode="center"
              />
        
      </View>
      </SafeAreaView>
      );
    }
  }
